import { darkTheme } from '@backstage/theme';

import { buildBuiTheme } from './buildBuiTheme';

/**
 * BUI Dark Theme for MUI v4 (Spotify variant)
 *
 * Uses the Spotify dark mode values from BUI tokens for the MUI palette.
 * Component overrides use CSS variables that automatically adapt.
 */
export const buiDarkTheme = buildBuiTheme({
  type: 'dark',
  palette: {
    // Primary - Spotify Green
    primary: {
      main: '#1ed760',
      light: '#3be477',
      dark: '#1abc54',
      contrastText: '#000000', // --bui-fg-solid (black on green)
    },
    // Secondary (using surface colors)
    secondary: {
      main: '#ffffff',
      light: '#ffffff',
      dark: '#f6f6f6',
      contrastText: '#000000',
    },
    // Error (--bui-fg-danger)
    error: {
      main: '#e22b2b',
      dark: '#e22b2b',
      light: '#f87a7a',
      contrastText: '#ffffff',
    },
    // Warning (--bui-fg-warning)
    warning: {
      main: '#e36d05',
      dark: '#e36d05',
      light: '#ffa42b',
      contrastText: '#000000',
    },
    // Info - using buiTheme info palette
    // info: {
    //   main: '#ffffff',
    //   dark: '#ffffff',
    //   light: '#0C6DDF',
    //   contrastText: '#000000',
    // },
    // Success (--bui-fg-success / Spotify green)
    success: {
      main: '#1db954',
      dark: '#1db954',
      light: '#53db83',
      contrastText: '#000000',
    },
    // Divider (--bui-border in dark mode = --bui-gray-3)
    divider: '#373737',
    // Navigation
    navigation: {
      ...darkTheme.palette.navigation,
      background: '#000000', // --bui-bg (black)
      color: '#9e9e9e', // --bui-fg-secondary / --bui-gray-7
      selectedColor: '#ffffff', // --bui-fg-primary
      submenu: {
        background: '#000000',
      },
    },
    // Text colors
    text: {
      primary: '#ffffff', // --bui-fg-primary
      secondary: '#9e9e9e', // --bui-fg-secondary / --bui-gray-7
      disabled: '#575757', // --bui-fg-disabled / --bui-gray-5
      hint: '#9e9e9e',
    },
    // Background colors (Spotify dark = black)
    background: {
      paper: '#101010', // --bui-bg-surface-1 / --bui-gray-1
      // paper: '#101010',
      // paper: '#000000', // --bui-bg-surface-1 / --bui-gray-1
      default: '#191919', // --bui-bg (black)
    },
    // Action colors
    action: {
      hover: '#202020', // --bui-bg-tint-hover
      hoverOpacity: 0.08,
      disabled: '#575757', // --bui-fg-disabled
      disabledBackground: '#292929', // --bui-bg-surface-2
      active: '#191919', // --bui-bg-surface-1
      focus: '#292929', // --bui-bg-tint-pressed
    },
  },
});
